export const state = {
  DATASETS: 'datasets',
  COLLECTION: 'collection',
  COLLECTIONS: 'collections',
  IS_LOADING: 'isLoading',
  SELECTED_DATASETS: 'selectedDatasets',
  OBS_VAR_COUNTS: 'observationVarCounts',
  SUBJ_VAR_COUNTS: 'subjectVarCounts',
};

export const getters = {};

export const mutations = {
  SET_DATASETS: 'setDatasets',
  SET_COLLECTION: 'setCollection',
  SET_COLLECTIONS: 'setCollections',
  ADD_COLLECTION: 'addCollection',
  SET_LOADING: 'setLoading',
  SET_SELECTED_DATASETS: 'setSelectedDatasets',
  CLEAR_SELECTED_DATASETS: 'clearSelectedDatasets',
  RENAME_COLLECTION: 'renameCollection',
  DELETE_COLLECTION: 'deleteCollection',
  SET_OBS_VAR_COUNTS: 'setObservationVarCounts',
  SET_SUBJ_VAR_COUNTS: 'setSubjectVarCounts',
  CLEAR_OBS_VAR_COUNTS: 'clearObservationVarCounts',
  CLEAR_SUBJ_VAR_COUNTS: 'clearSubjectVarCounts',
};

export const actions = {
  FETCH_DATASETS: 'fetchDatasets',
  FETCH_COLLECTION: 'fetchCollection',
  FETCH_COLLECTIONS: 'fetchCollections',
  SELECT_DATASETS: 'selectDatasets',
  SAVE_COLLECTION: 'saveCollection',
  RENAME_COLLECTION: 'renameCollection',
  DELETE_COLLECTION: 'deleteCollection',
  CLEAR_COLLECTION: 'clearCollection',
  FETCH_OBS_VAR_COUNTS: 'fetchObservationVarCounts',
  FETCH_SUBJ_VAR_COUNTS: 'fetchSubjectVarCounts',
  GET_VARIABLE_DATA: 'getVariableData',
};
